import { createSlice } from '@reduxjs/toolkit'


const initialState = {
    isLoading: false,
    operationType: undefined,
    participantsAttendanceChannel: null,
    participantsAttendanceMap: new Map(),
    instructorsAttendaceChannel: null,
    instructorsAttendanceMap: new Map(),
    allInstructorsEvents: null,
    allParticipantsEvents: null,
    attendanceLoading: false,
    parentMarking: false
}


export const calendarSlice = createSlice({
    name: 'attendance',
    initialState: { ...initialState },
    reducers: {
        attendanceSagaSuccess: (state, action) => {
            if (action.payload) {
                Object.assign(state, action.payload);
            }
        },
        attendanceSagaFailed: (state, action) => {
            state.isLoading = false;
            state.operationType = undefined;
            if (action.payload) {
                Object.assign(state, action.payload);
            }
        },
        resetAttendanceReducer: (state, action) => {
            if (action.payload) {
                Object.assign(state, action.payload);
            }
        },
        getParticipantsSlotAttendance: (state, action) => {
            state.isLoading = true;
        },
        getInstructorsSlotAttendance: (state, action) => {
            state.isLoading = true;
        },
        markSlotBulkAttendance: (state, payload) => {
            state.isLoading = true;
        },
        getParticipantsDateRangeAttendance: (state, action) => {
            state.attendanceLoading = true;
        },
        getInstructorsDateRangeAttendance: (state, action) => {
            state.attendanceLoading = true;
        },
        getAllEventsOfParticipants: (state, action) => {
            state.isLoading = true;
        },
        getAllEventsOfInstructors: (state, action) => {
            state.isLoading = true;
        },
        markDateRangeBulkAttendance: (state, action) => {
            state.isLoading = true;
        },
        markMultipleEventsBulkAttendance: (state, action) => {
            state.isLoading = true;
        },
        resetOperationType: (state, action) => {
            state.operationType = ""
        },
        getParticipantsDateRangeAttendanceByAccountId: (state, action) => {
            state.isLoading = true;
        },
        getParticipantsScheduleAttendanceByAccountId: (state, action) => {
            state.isLoading = true;
        },
        markParentAttendance: (state, action) => {
            state.parentMarking = true;
        }
    }
});


export const {
    attendanceSagaSuccess,
    attendanceSagaFailed,
    resetAttendanceReducer,
    getParticipantsSlotAttendance,
    getInstructorsSlotAttendance,
    markSlotBulkAttendance,
    getParticipantsDateRangeAttendance,
    getInstructorsDateRangeAttendance,
    getAllEventsOfParticipants,
    getAllEventsOfInstructors,
    markDateRangeBulkAttendance,
    markMultipleEventsBulkAttendance,
    resetOperationType,
    getParticipantsDateRangeAttendanceByAccountId,
    getParticipantsScheduleAttendanceByAccountId,
    markParentAttendance
} = calendarSlice.actions


export const defaultAttendanceReducerState = { ...initialState };

export default calendarSlice.reducer